import React from "react";
import styles from "./Badge.module.css";
import { joinClassNames } from "../../utils/joinClassNames";

export type BadgeProps = {
    label: string;
    className?: string;
};

export const Badge = ({ label, className = "" }: BadgeProps) => {
    if (!label.trim()) {
        return null;
    }

    const labels = label.split(";").map((tag) => tag.trim());

    return (
        <div className="badgeWrapper">
            {labels.map(
                (label, index) =>
                    label && (
                        <span
                            key={index}
                            className={joinClassNames([
                                styles.badge,
                                className,
                            ])}
                        >
                            {label}
                        </span>
                    )
            )}
        </div>
    );
};

export default Badge;
